// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O-Nw9","type":"styles_type__RSTrb","choices":"styles_choices__3y_PK"};